module.exports = __webpack_public_path__ + "static/img/image1.d0aa3478.png";